import { useState } from "react";
import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import type { RemoveBillingGroupModalProps } from "./types";

export const RemoveBillingGroupModal = ({
  isOpen,
  onClose,
  onSubmit,
  billingGroupName,
  selectedGroupCount,
}: RemoveBillingGroupModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) {
    return null;
  }

  const groupLabel = selectedGroupCount === 1 ? "billing group" : "billing groups";

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalV2
      show={isOpen}
      onHide={onClose}
      title="Remove billing group"
      description={`${selectedGroupCount} selected ${groupLabel}`}
      data-testid="remove-billing-group-modal"
    >
      <ModalV2.Body>
        <Text variant="regular-md">
          The billing group &quot;{billingGroupName}&quot; will be removed and all its entities
          will be unassigned.
        </Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button variant="neutral" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
            Submit for approval
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
